export const PROJECT = "PROJECT";
export const SQUARE = "SQUARE";
export const LAND = "LAND";



// WEBPACK FOOTER //
// ./src/constants/geoConstants.js